/* eslint-disable */
import {
  createContext,
  useContext,
  useReducer,
  useMemo,
  useEffect,
} from "react";
import getLayerId from "utils/getLayerId";
import { useAuth } from "./auth";
// Auth context
const esriUrlsContext = createContext();
// Setting custom name for the context which is visible on react dev tools
esriUrlsContext.displayName = "Esri Urls Context";

// reducer
function reducer(state, action) {
  switch (action.type) {
    case "INIT": {
      return { ...state, ...action.payload };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// context provider
function EsriUrlsContextProvider({ children }) {
  const initialState = {
    Poles: "",
    Municipalities: "",
    Pallets: "",
    Pallets_History: "",
    Units: "",
    Units_History: "",
  };

  const [auth] = useAuth();
  const { token } = auth;

  const [controller, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);
  useEffect(() => {
    // self invoked function to get the esri urls
    (async () => {
      // serviceName
      // tableOrLayerName
      if (token) {
        const services = [
          {
            serviceName: process.env.REACT_APP_YELLOW_DOOR_SERVICE,
            tableName: "Poles",
          },
          {
            serviceName: process.env.REACT_APP_YELLOW_DOOR_SERVICE,
            tableName: "Municipalities",
          },
          {
            serviceName: process.env.REACT_APP_YELLOW_DOOR_SERVICE,
            tableName: "Pallets",
          },
          {
            serviceName: process.env.REACT_APP_YELLOW_DOOR_SERVICE,
            tableName: "Pallets_History",
          },
          {
            serviceName: process.env.REACT_APP_YELLOW_DOOR_SERVICE,
            tableName: "Units",
          },
          {
            serviceName: process.env.REACT_APP_YELLOW_DOOR_SERVICE,
            tableName: "Units_History",
          },
          {
            serviceName: process.env.REACT_APP_YELLOW_DOOR_SERVICE,
            tableName: "Job_Zones",
          },
        ];
        const layerIdsReq = services.map((service) =>
          getLayerId(service["serviceName"], service["tableName"], token)
        );
        const layerIdsRes = await Promise.all(layerIdsReq);
        const layers = {};
        layerIdsRes.map((id, index) => {
          if (services[index]["customName"]) {
            return (layers[services[index]["customName"]] = id);
          }
          return (layers[services[index]["tableName"]] = id);
        });
        dispatch({ type: "INIT", payload: layers });
      }
    })();
  }, [token]);

  return (
    <esriUrlsContext.Provider value={value}>
      {children}
    </esriUrlsContext.Provider>
  );
}

// custom hook for using context
function useEsriUrls() {
  const context = useContext(esriUrlsContext);

  if (!context) {
    throw new Error(
      "useEsriUrls should be used inside the EsriUrlsContextProvider."
    );
  }

  return context;
}

// Context module functions

export { EsriUrlsContextProvider, useEsriUrls };
